// extracted by mini-css-extract-plugin
export default {"cards":"RedCards_cards__1r2A4","red":"RedCards_red__ejXDI","yellow":"RedCards_yellow__hbSKV"};